import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import * as firebase from 'firebase'
import './App.css'
import AddSinglePage from './pages/AddSingle.js'
import FriendsPage from './pages/Friends.js'
import LoginPage from './pages/Login.js'
import Menu from './pages/Menu.js'
import PageHeader from './pages/Header.js'
import ProfilePage from './pages/Profile.js'
import SearchPage from './pages/Search.js'

export default class App extends Component {
  constructor () {
    super()

    this.state = {
      user: null,
      loading: true,
      page: 'friends'
    }

    this.userRef = null
    this.tasksRef = null

    var user = firebase.auth().currentUser
    if (user) {
      this.subscribe(user.uid)
    }
  }

  componentDidMount () {
    var self = this

    firebase.auth().getRedirectResult().then(function (result) {
      // Success, auth state change will store the user
    }).catch(function (error) {
      console.error(error)
    })

    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        console.info(user)

        // Subscribe to users/uid database
        self.subscribe(user.uid)

        // Save user data in database
        self.processLogin(user)
      } else {
        // Stop listening for database changes
        self.unsubscribe()

        // Remove user from state
        self.saveUser(null)
      }
    })
  }

  processLogin (user) {
    this.createProcessLoginTask(user)
  }

  subscribe (userId) {
    // Make sure we're not listening for another user
    this.unsubscribe()

    this.userRef = firebase.database().ref().child('users/' + userId)
    this.userRef.on('value', snap => {
      // Put user data in state
      this.saveUser(snap.val())
    })
  }

  unsubscribe () {
    if (this.userRef != null) {
      this.userRef.off('value')
      this.userRef = null
    }
  }

  setLoading (loading) {
    this.setStateValueForKey(loading, 'loading')
  }

  saveUser (user) {
    this.setStateValueForKey(user, 'user')
    this.setLoading(false)
  }

  setStateValueForKey (value, key) {
    var state = this.state
    state[key] = value
    this.setState(state)
  }

  render () {
    const loggedIn = (this.state.user !== null)

    if (!loggedIn) {
      return (
        <div>
          <link rel='stylesheet' href='https://maxcdn.bootstrapcdn.com/bootstrap/latest/css/bootstrap.min.css' />
          <div className='container-fluid Page'>
            <div className='container App'>
              <LoginPage loading={this.state.loading} onLoginClicked={this.onLoginClicked} />
            </div>
          </div>
        </div>
      )
    } else {
      var header = <PageHeader uid={this.state.user.uid} onLogoutClicked={this.onLogoutClicked} />
      var menu = <Menu selected={this.state.page} onPageSelected={this.onPageSelected} />

      var page = null
      if (this.state.page === 'profile') {
        page = <ProfilePage uid={this.state.user.uid} />
      } else if (this.state.page === 'addSingle') {
        page = <AddSinglePage uid={this.state.user.uid} onPageSelected={this.onPageSelected} />
      } else if (this.state.page === 'friends') {
        page = <FriendsPage uid={this.state.user.uid} loading={true} />
      } else if (this.state.page === 'addFriends') {
        page = <SearchPage uid={this.state.user.uid} loading={true} />
      }

      return (
        <div>
          <link rel='stylesheet' href='https://maxcdn.bootstrapcdn.com/bootstrap/latest/css/bootstrap.min.css' />
          <div className='container-fluid Page'>
            <div className='container App' style={{paddingLeft: '0px', paddingRight: '0px'}}>
              <Grid fluid style={{height: '100%'}}>
                <Row>
                  <Col xs={12}>
                    {header}
                  </Col>
                </Row>
                <Row style={{height: '100%'}}>
                  <Col md={2} sm={12}>
                    {menu}
                  </Col>
                  <Col md={10} sm={12} style={{height: '100%'}}>
                    {page}
                  </Col>
                </Row>
              </Grid>
            </div>
          </div>
        </div>
      )
    }
  }

  onLoginClicked = () => {
    this.setLoading(true)

    var provider = new firebase.auth.FacebookAuthProvider()
    provider.addScope('public_profile')
    provider.addScope('email')
    provider.addScope('user_friends')
    provider.addScope('user_birthday')
    provider.addScope('user_hometown')

    firebase.auth().signInWithRedirect(provider)
  }

  onLogoutClicked = () => {
    firebase.auth().signOut()
  }

  onPageSelected = (page) => {
    // Force profile page if not complete
    var user = this.state.user
    if (page !== 'profile' && (!user.hasOwnProperty('single') || !user.dateOfBirth || !user.gender || !user.interests || Object.keys(user.interests).length === 0)) {
      this.setStateValueForKey('profile', 'page')
    } else {
      this.setStateValueForKey(page, 'page')
    }
  }

  createProcessLoginTask = (user) => {
    console.log('Creating process_login task with user: ' + JSON.stringify(user))

    // Initialize firebase tasks reference on-demand
    if (this.tasksRef === null) {
      this.tasksRef = firebase.database().ref().child('queue/tasks')
    }

    // Push a new process_login task on the queue
    this.tasksRef.push({
      task: 'process_login',
      uid: user.uid,
      profile: {
        uid: user.uid,
        displayName: user.displayName,
        email: user.email,
        photoURL: user.photoURL,
        providerData: user.providerData
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/App.js